export const  isCheckDateSpecial = (date:any | string) => {    
    let bits = date.split('/');  
    let y = bits[0],
      m = bits[1],
      d = bits[2];
    let daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if ((!(y % 4) && y % 100) || !(y % 400)) {
      daysInMonth[1] = 29;
    }
    return !(/\D/.test(String(d))) && d > 0 && d <= daysInMonth[--m]
  }